export function setCookie(name, value, options = {}) {
  const {
    days = 180,
    path = "/",
    sameSite = "Lax",
    secure = window.location.protocol === "https:",
  } = options;

  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const encName = encodeURIComponent(name);
  const encValue = encodeURIComponent(value);

  let cookie = `${encName}=${encValue}; Expires=${expires}; Path=${path}; SameSite=${sameSite}`;
  if (secure) cookie += "; Secure";
  document.cookie = cookie;
}

export function getCookie(name) {
  const encName = encodeURIComponent(name) + "=";
  const parts = document.cookie.split(/;\s*/);
  for (const p of parts) {
    if (p.startsWith(encName)) {
      return decodeURIComponent(p.slice(encName.length));
    }
  }
  return null;
}

export function deleteCookie(name, options = {}) {
  const { path = "/" } = options;
  document.cookie = `${encodeURIComponent(name)}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=${path}; SameSite=Lax`;
}
